import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, Facebook, Instagram } from "lucide-react";
import { useSite, useCompany } from "@/context/SiteContext";
import { Logo } from "./Header";

export default function Footer() {
  const { site } = useSite();
  const c = useCompany();
  const cta = site?.content?.cta || {};
  const areas = site?.service_areas || [];
  return (
    <footer className="ib-grain bg-[color:var(--ib-charcoal)] text-white" data-testid="site-footer">
      <div className="mx-auto grid max-w-[1400px] gap-12 px-5 py-14 lg:grid-cols-[1.1fr_1fr_1fr] lg:px-8">
        <div>
          <Logo light className="h-14" />
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-white/70">{c.service_area_summary}</p>
          <div className="mt-5 flex gap-4 text-white/70">
            {c.facebook && <a href={c.facebook} aria-label="Facebook" className="hover:text-white"><Facebook size={18} /></a>}
            {c.instagram && <a href={c.instagram} aria-label="Instagram" className="hover:text-white"><Instagram size={18} /></a>}
          </div>
        </div>
        <div>
          <h2 className="font-display text-2xl uppercase tracking-wide">{cta.title}</h2>
          <p className="mt-2 text-white/70">{cta.subtitle}</p>
          <Link to="/contact" className="ib-btn ib-btn-primary mt-5" data-testid="footer-get-quote-btn">{cta.button || "Get a Quote"}</Link>
          <ul className="mt-8 grid grid-cols-2 gap-2 text-sm text-white/70">
            {(site?.services || []).map((s) => <li key={s.id}><Link className="hover:text-white" to={`/services/${s.slug}`}>{s.title}</Link></li>)}
            {areas.map((a) => <li key={a.id}><Link className="hover:text-white" to={`/service-areas/${a.slug}`}>{a.name}</Link></li>)}
          </ul>
        </div>
        <div>
          <p className="font-display text-xl uppercase tracking-wide text-[color:var(--ib-orange)]">Contact Us</p>
          <ul className="mt-4 space-y-3 text-sm text-white/85">
            <li className="flex gap-3"><Phone size={16} className="mt-0.5 shrink-0" /><a href={`tel:${(c.phone || "").replace(/\D/g, "")}`} data-testid="footer-phone">{c.phone}</a></li>
            <li className="flex gap-3"><Mail size={16} className="mt-0.5 shrink-0" /><span className="flex flex-col"><a href={`mailto:${c.email}`} data-testid="footer-email">{c.email}</a>{c.email2 && <a href={`mailto:${c.email2}`}>{c.email2}</a>}</span></li>
            <li className="flex gap-3"><MapPin size={16} className="mt-0.5 shrink-0" />{c.address}</li>
            <li className="flex gap-3"><Clock size={16} className="mt-0.5 shrink-0" />{c.hours}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-[1400px] flex-col justify-between gap-2 px-5 py-5 text-xs uppercase tracking-[0.16em] text-white/50 sm:flex-row lg:px-8">
          <span>© {new Date().getFullYear()} {c.name}</span>
          <span data-testid="footer-license">{c.license_label || "General Contractor"} | Lic. #{c.license}</span>
        </div>
      </div>
    </footer>
  );
}
